import { format, labelsFor } from "@fortex/map";
import type { Labels } from "@fortex/map";

export type AppLang = "hu" | "en";

const hu = {
  appName: "ForteX",
  appTitle: "ForteX térkép",
  mapPage: "Térkép",
  skipToContent: "Ugrás a tartalomra",
  menu: "Menü",
  loginTitle: "Bejelentkezés",
  loginIntro: "Jelentkezzen be a szerkesztéshez és az adminisztrációhoz.",
  loginSubmit: "Bejelentkezés",
  loginRequired: "A folytatáshoz bejelentkezés szükséges",
  emailRequired: "Adja meg az e-mail címet",
  passwordRequired: "Adja meg a jelszót",
  currentPassword: "Jelenlegi jelszó",
  newPassword: "Új jelszó",
  confirmPassword: "Új jelszó még egyszer",
  passwordMismatch: "A két jelszó nem egyezik",
  passwordChanged: "A jelszó módosult",
  signedInAs: "Bejelentkezve: {name}",
  accessDenied: "Ehhez a felülethez nincs jogosultsága",
  adminHome: "Adminisztráció",
  mapTree: "MAP fa",
  layerTree: "LAYER fa",
  treeLoading: "A fa betöltése",
  treeEmpty: "A fa üres",
  treeReload: "Újratöltés",
  rootNode: "Gyökér",
  newNode: "Új elem",
  newTile: "Új csempe réteg",
  newSpecial: "Új szolgáltatói réteg",
  newFolder: "Új mappa réteg",
  newGeoObject: "Új objektum réteg",
  newChild: "Új elem ide",
  moveTo: "Áthelyezés",
  moveFailed: "Az áthelyezés nem sikerült",
  moved: "Áthelyezve",
  show: "Megjelenítés",
  hide: "Elrejtés",
  deleteNodeText: "A(z) {name} elem és minden alárendelt eleme törlődik.",
  deleted: "Törölve",
  deleteFailed: "A törlés nem sikerült",
  duplicated: "Másolat létrehozva",
  problemsCount: "{count} probléma",
  jumpTo: "Ugrás",
  problemUnknownKind: "ismeretlen típus: {value}",
  problemInvalidJson: "a beállítások nem érvényes JSON",
  problemLeafWithChildren: "levél elemnek vannak gyermekei",
  problemTileNoUrl: "a csempe réteghez urlTemplate kell",
  problemSpecialNoProvider: "a szolgáltatói réteghez provider kell",
  problemKindNotAllowed: "a {kind} típus itt nem engedélyezett",
  idNameRequired: "Az azonosító kötelező",
  idNamePrefix: "Az azonosító {prefix} előtaggal kezdődjön",
  idNameChars: "Csak nagybetű, szám és aláhúzás használható",
  idNameTaken: "Ez az azonosító már létezik",
  nameHu: "Név (magyar)",
  nameEn: "Név (angol)",
  nameRequired: "A magyar név kötelező",
  parent: "Szülő",
  settingsJson: "Beállítások JSON",
  settingsInvalidJson: "A JSON nem érvényes",
  kindGroup: "Csoport",
  kindTile: "Csempe",
  kindSpecial: "Szolgáltató",
  kindFolder: "Mappa",
  kindGeoObject: "Objektum",
  subdomains: "Aldomainek",
  attribution: "Forrásmegjelölés",
  minZoom: "Min. zoom",
  maxZoom: "Max. zoom",
  maxNativeZoom: "Max. natív zoom",
  tileSize: "Csempe méret",
  detectRetina: "Retina felismerés",
  previewFailed: "Az előnézeti csempe nem tölthető be",
  providerKey: "API kulcs",
  providerOptions: "További beállítások (kulcs=érték soronként)",
  selectionMode: "Kijelölés",
  selectionSingle: "Egy választható",
  selectionMulti: "Több választható",
  collapsed: "Összecsukva alapból",
  defaultOn: "Alapból bekapcsolva",
  noCache: "Csempék gyorsítótár nélkül (nocache)",
  penColor: "Vonal színe",
  penWidth: "Vonal vastagsága",
  penDash: "Vonal mintája",
  dashSolid: "Folytonos",
  dashDash: "Szaggatott",
  dashDot: "Pontozott",
  dashDashDot: "Szaggatott-pontozott",
  dashDashDotDot: "Szaggatott-két pont",
  fillColor: "Kitöltés színe",
  fillOpacity: "Kitöltés átlátszósága",
  iconNormal: "Ikon",
  iconSelected: "Kijelölt ikon",
  iconHovered: "Ikon egér fölött",
  iconUpload: "Kép kiválasztása",
  iconRemove: "Ikon törlése",
  iconPreview: "Jelölő előnézet",
  iconInvalid: "A fájl nem olvasható képként",
  includeDescendants: "Leszármazott típusok is",
  cluster: "Csoportosítás",
  labels: "Feliratok",
  simplify: "Egyszerűsítés",
  maxFeatures: "Legfeljebb ennyi elem",
  anySld: "Minden SLD réteg",
  nodeSaved: "Az elem mentve",
  selectNode: "Válasszon elemet a fában, vagy hozzon létre újat",
  userStatus: "Állapot",
  statusAll: "Mind",
  statusActive: "Aktív",
  statusInactive: "Inaktív",
  searchUsers: "Keresés név vagy e-mail alapján",
  userCreated: "A felhasználó létrejött",
  userUpdated: "A felhasználó mentve",
  userDeleted: "A felhasználó törölve",
  deleteUserText: "A(z) {name} felhasználó véglegesen törlődik.",
  activate: "Aktiválás",
  deactivate: "Inaktiválás",
  administrator: "Adminisztrátor",
  passwordReset: "Az új jelszó beállítva",
  passwordMinLength: "A jelszó legalább 6 karakter",
  rolesOfUser: "Felhasználó szerepkörei",
  rolesSaved: "A szerepkörök mentve",
  noRoles: "Nincs szerepkör",
  rolePick: "Válasszon szerepkört a jogosultságok szerkesztéséhez",
  grantsSaved: "A jogosultságok mentve",
  userCount: "{count} felhasználó",
  featureCount: "{count} funkció",
  feature: "Funkció",
  accessLevel: "Hozzáférés",
  embedReady: "A beágyazott térkép kész",
  embedOriginRejected: "A parancs forrása nem engedélyezett",
  embedBadCommand: "Ismeretlen parancs",
  notFoundTitle: "Az oldal nem található",
  goHome: "Vissza a térképhez",
  actions: "Műveletek",
  edit: "Szerkesztés",
  openMenu: "Menü megnyitása",
  required: "Kötelező",
  loadFailedGeneric: "Az adatok betöltése nem sikerült",
  menuMap: "Térkép",
  menuMasterData: "Törzsadatok",
  menuMaps: "Térképek",
  menuLayers: "Rétegek",
  menuUsers: "Felhasználók",
  backToMap: "Vissza a térképre",
  adminTitle: "Admin",
  newMasterData: "Új törzsadat",
  newUser: "Új felhasználó",
  refresh: "Frissítés",
  exportCsv: "Exportálás (CSV)",
  groupByTree: "Csoportosítás a fa szerint",
  closeDetail: "Részletek bezárása",
  openInWindow: "Megnyitás ablakban",
  dockDetail: "Megnyitás oldalsávban",
  editMasterData: "Törzsadat szerkesztése",
  colId: "Id",
  colIcon: "Ikon",
  colName: "Név",
  colIdName: "IdName",
  colValue: "Érték",
  colValue2: "Érték 2",
  colDataId: "DataId",
  colOrder: "Sorrend",
  colVisible: "Látható",
  colParent: "Szülő",
  rootLevel: "Gyökér",
  sectionIdentity: "Azonosítás",
  sectionValues: "Értékek",
  sectionNames: "Megnevezés",
  sectionAppearance: "Megjelenés",
  sectionMapSettings: "Térkép beállítások",
  sectionAccount: "Alapadatok",
  sectionPassword: "Jelszó",
  sectionRoles: "Szerepkörök és állapot",
  deleteMasterDataText: "A(z) {name} törzsadat törlődik.",
  pickRow: "Válasszon sort a listából, vagy hozzon létre újat",
  parentRequired: "Válasszon szülőt",
  noParent: "Nincs",
  valueRequired: "Az érték kötelező",
  mapSettingsHint: "A MAP és LAYER fa elemeinél a típus és a beállítások is itt szerkeszthetők",
  menuPublicMaps: "Publikus térképek",
  publicMapCreate: "Publikus térkép létrehozása",
  publicMapEdit: "Publikus térkép szerkesztése",
  publicMapNotFound: "A publikus térkép nem található",
  publicMapLoading: "A publikus térkép betöltése",
  publicMapLink: "Publikus hivatkozás",
  publicMapLinkCopied: "A hivatkozás a vágólapra került",
  publicMapName: "Név",
  publicMapDescription: "Leírás",
  publicMapBasics: "Alapadatok",
  publicMapLayers: "Térképek és rétegek",
  publicMapLayersHint: "A bejelölt elemek jelennek meg a publikus térképen",
  publicMapDefaultOn: "Alapból bekapcsolva",
  publicMapSearchable: "Kereshető",
  publicMapView: "Kezdő nézet",
  publicMapLat: "Szélesség",
  publicMapLon: "Hosszúság",
  publicMapZoom: "Nagyítás",
  publicMapFeatures: "Funkciók",
  publicMapNeedsLayer: "Legalább egy térkép vagy réteg szükséges",
  publicMapNameRequired: "A név kötelező",
  publicMapViewInvalid: "A kezdő nézet értékei érvénytelenek",
  publicMapSaved: "A publikus térkép mentve",
  publicMapDeleted: "A publikus térkép törölve",
  publicMapDeleteText: "A(z) {name} publikus térkép törlődik, a hivatkozás nem fog működni.",
  publicMapLayerCount: "Rétegek",
  publicMapUpdated: "Módosítva",
  publicMapOpenAdmin: "Publikus térképek kezelése",
  publicMapOpen: "Megnyitás",
  publicMapSearchLabel: "Keresési felirat",
  publicMapSearchLabelHint: "Üresen a kereshető rétegek saját feliratai jelennek meg",
  searchLabel: "Keresési felirat",
  searchLabelHint: "A keresőmező felett jelenik meg, amikor a réteg be van kapcsolva",
  layerData: "Számított adatok",
  layerStateNotCalculated: "Nincs kiszámítva",
  layerStateCalculating: "Számítás folyamatban",
  layerStateCalculated: "Kész",
  layerStateFailed: "Hiba",
  layerDataBounds: "Határoló téglalap",
  layerDataMinLat: "Min. szélesség",
  layerDataMinLon: "Min. hosszúság",
  layerDataMaxLat: "Max. szélesség",
  layerDataMaxLon: "Max. hosszúság",
  layerDataTable: "Tábla",
  layerDataCalculatedDate: "Számítás ideje",
  layerDataDuration: "Időtartam",
  layerDataSeconds: "{seconds} mp",
  layerDataError: "Hibaüzenet",
  refreshAllLayers: "Összes frissítése",
  layersRefreshed: "Frissítésre jelölve: {reset}, kihagyva: {skipped}",
  menuApiKeys: "API kulcsok",
  newApiKeyUser: "Új API kulcs",
  editApiKeyUser: "API kulcs szerkesztése",
  apiKeyName: "Név",
  apiKeyNameRequired: "A név kötelező",
  apiKeyCreateHint: "Mentéskor létrejön a kulcs, és egyszer megjelenik. A szerepkörök mentés után állíthatók be.",
  sectionApiKeys: "Kulcsok",
  apiKeyRoll: "Új kulcs",
  apiKeyRollText: "Új kulcs készül. A régi kulcs a megadott percig még érvényes marad.",
  apiKeyGraceMinutes: "A régi kulcs érvényessége (perc)",
  apiKeyGraceHint: "0 esetén a régi kulcs azonnal érvénytelen lesz",
  apiKeyGraceInvalid: "Adjon meg egy egész számot 0 és {max} között",
  apiKeyRevoke: "Visszavonás",
  apiKeyRevokeText: "A(z) {prefix} kezdetű kulcs azonnal érvénytelen lesz.",
  apiKeyRevokedText: "A kulcs visszavonva",
  apiKeyNone: "Nincs kulcs",
  apiKeyValid: "Érvényes",
  apiKeyNotValid: "Érvénytelen",
  apiKeyCreated: "Létrehozva",
  apiKeyExpires: "Lejár",
  apiKeyRevoked: "Visszavonva",
  apiKeyLastUsed: "Utoljára használva",
  apiKeyNeverUsed: "még nem",
  apiKeyIssuedTitle: "Az új API kulcs",
  apiKeyIssuedText: "Másolja ki most. A kulcs később nem jeleníthető meg újra.",
  apiKeyCopied: "Másolva",
  apiKeyUserSaved: "Az API kulcs mentve",
  apiKeyUserDeleted: "Az API kulcs törölve",
  deleteApiKeyUserText: "A(z) {name} API kulcs felhasználó inaktív lesz, a kulcsai nem működnek tovább.",
  tableTitle: "Table",
  tableFilterOptions: "Filter Options",
  tableChangedFrom: "Változtatás -tól",
  tableChangedTo: "Változtatás -ig",
  tableRefresh: "Frissít"
};

const en: typeof hu = {
  appName: "ForteX",
  appTitle: "ForteX map",
  mapPage: "Map",
  skipToContent: "Skip to content",
  menu: "Menu",
  loginTitle: "Sign in",
  loginIntro: "Sign in to edit and to reach the administration.",
  loginSubmit: "Sign in",
  loginRequired: "Sign in to continue",
  emailRequired: "Enter the e-mail address",
  passwordRequired: "Enter the password",
  currentPassword: "Current password",
  newPassword: "New password",
  confirmPassword: "Repeat the new password",
  passwordMismatch: "The two passwords differ",
  passwordChanged: "The password was changed",
  signedInAs: "Signed in as {name}",
  accessDenied: "You have no access to this screen",
  adminHome: "Administration",
  mapTree: "MAP tree",
  layerTree: "LAYER tree",
  treeLoading: "Loading the tree",
  treeEmpty: "The tree is empty",
  treeReload: "Reload",
  rootNode: "Root",
  newNode: "New node",
  newTile: "New tile layer",
  newSpecial: "New provider layer",
  newFolder: "New folder layer",
  newGeoObject: "New object layer",
  newChild: "New node here",
  moveTo: "Move",
  moveFailed: "The move failed",
  moved: "Moved",
  show: "Show",
  hide: "Hide",
  deleteNodeText: "{name} and every node under it will be deleted.",
  deleted: "Deleted",
  deleteFailed: "The delete failed",
  duplicated: "Copy created",
  problemsCount: "{count} problems",
  jumpTo: "Jump",
  problemUnknownKind: "unknown kind: {value}",
  problemInvalidJson: "the settings are not valid JSON",
  problemLeafWithChildren: "a leaf node has children",
  problemTileNoUrl: "a Tile node needs urlTemplate",
  problemSpecialNoProvider: "a Special node needs provider",
  problemKindNotAllowed: "kind {kind} is not allowed here",
  idNameRequired: "The id name is required",
  idNamePrefix: "The id name must start with {prefix}",
  idNameChars: "Only upper case letters, digits and underscores are allowed",
  idNameTaken: "This id name already exists",
  nameHu: "Name (Hungarian)",
  nameEn: "Name (English)",
  nameRequired: "The Hungarian name is required",
  parent: "Parent",
  settingsJson: "Settings JSON",
  settingsInvalidJson: "The JSON is not valid",
  kindGroup: "Group",
  kindTile: "Tile",
  kindSpecial: "Provider",
  kindFolder: "Folder",
  kindGeoObject: "Object",
  subdomains: "Subdomains",
  attribution: "Attribution",
  minZoom: "Min zoom",
  maxZoom: "Max zoom",
  maxNativeZoom: "Max native zoom",
  tileSize: "Tile size",
  detectRetina: "Detect retina",
  previewFailed: "The preview tile could not be loaded",
  providerKey: "API key",
  providerOptions: "More options (key=value per line)",
  selectionMode: "Selection",
  selectionSingle: "Single",
  selectionMulti: "Multiple",
  collapsed: "Collapsed by default",
  defaultOn: "On by default",
  noCache: "Tiles without cache (nocache)",
  penColor: "Line colour",
  penWidth: "Line width",
  penDash: "Line pattern",
  dashSolid: "Solid",
  dashDash: "Dashed",
  dashDot: "Dotted",
  dashDashDot: "Dash dot",
  dashDashDotDot: "Dash dot dot",
  fillColor: "Fill colour",
  fillOpacity: "Fill opacity",
  iconNormal: "Icon",
  iconSelected: "Selected icon",
  iconHovered: "Hovered icon",
  iconUpload: "Choose an image",
  iconRemove: "Remove icon",
  iconPreview: "Marker preview",
  iconInvalid: "The file could not be read as an image",
  includeDescendants: "Include descendant types",
  cluster: "Cluster",
  labels: "Labels",
  simplify: "Simplify",
  maxFeatures: "Max features",
  anySld: "Every SLD layer",
  nodeSaved: "The node was saved",
  selectNode: "Pick a node in the tree or create a new one",
  userStatus: "Status",
  statusAll: "All",
  statusActive: "Active",
  statusInactive: "Inactive",
  searchUsers: "Search by name or e-mail",
  userCreated: "The user was created",
  userUpdated: "The user was saved",
  userDeleted: "The user was deleted",
  deleteUserText: "The user {name} will be deleted permanently.",
  activate: "Activate",
  deactivate: "Deactivate",
  administrator: "Administrator",
  passwordReset: "The new password is set",
  passwordMinLength: "The password needs at least 6 characters",
  rolesOfUser: "Roles of the user",
  rolesSaved: "The roles were saved",
  noRoles: "No roles",
  rolePick: "Pick a role to edit its grants",
  grantsSaved: "The grants were saved",
  userCount: "{count} users",
  featureCount: "{count} features",
  feature: "Feature",
  accessLevel: "Access",
  embedReady: "The embedded map is ready",
  embedOriginRejected: "The command origin is not allowed",
  embedBadCommand: "Unknown command",
  notFoundTitle: "Page not found",
  goHome: "Back to the map",
  actions: "Actions",
  edit: "Edit",
  openMenu: "Open menu",
  required: "Required",
  loadFailedGeneric: "The data could not be loaded",
  menuMap: "Map",
  menuMasterData: "Master data",
  menuMaps: "Maps",
  menuLayers: "Layers",
  menuUsers: "Users",
  backToMap: "Back to the map",
  adminTitle: "Admin",
  newMasterData: "New master data",
  newUser: "New user",
  refresh: "Refresh",
  exportCsv: "Export (CSV)",
  groupByTree: "Group by the tree",
  closeDetail: "Close details",
  openInWindow: "Open in a window",
  dockDetail: "Open in the side pane",
  editMasterData: "Edit master data",
  colId: "Id",
  colIcon: "Icon",
  colName: "Name",
  colIdName: "IdName",
  colValue: "Value",
  colValue2: "Value 2",
  colDataId: "DataId",
  colOrder: "Order",
  colVisible: "Visible",
  colParent: "Parent",
  rootLevel: "Root",
  sectionIdentity: "Identity",
  sectionValues: "Values",
  sectionNames: "Names",
  sectionAppearance: "Appearance",
  sectionMapSettings: "Map settings",
  sectionAccount: "Account",
  sectionPassword: "Password",
  sectionRoles: "Roles and state",
  deleteMasterDataText: "The master data {name} will be deleted.",
  pickRow: "Pick a row from the list or create a new one",
  parentRequired: "Pick a parent",
  noParent: "None",
  valueRequired: "The value is required",
  mapSettingsHint: "For MAP and LAYER tree nodes the kind and the settings are edited here as well",
  menuPublicMaps: "Public maps",
  publicMapCreate: "Create public map",
  publicMapEdit: "Edit public map",
  publicMapNotFound: "The public map was not found",
  publicMapLoading: "Loading the public map",
  publicMapLink: "Public link",
  publicMapLinkCopied: "The link was copied to the clipboard",
  publicMapName: "Name",
  publicMapDescription: "Description",
  publicMapBasics: "Basics",
  publicMapLayers: "Maps and layers",
  publicMapLayersHint: "Checked items are shown on the public map",
  publicMapDefaultOn: "On by default",
  publicMapSearchable: "Searchable",
  publicMapView: "Initial view",
  publicMapLat: "Latitude",
  publicMapLon: "Longitude",
  publicMapZoom: "Zoom",
  publicMapFeatures: "Features",
  publicMapNeedsLayer: "At least one map or layer is required",
  publicMapNameRequired: "The name is required",
  publicMapViewInvalid: "The initial view values are invalid",
  publicMapSaved: "The public map was saved",
  publicMapDeleted: "The public map was deleted",
  publicMapDeleteText: "The public map {name} will be deleted and its link will stop working.",
  publicMapLayerCount: "Layers",
  publicMapUpdated: "Updated",
  publicMapOpenAdmin: "Manage public maps",
  publicMapOpen: "Open",
  publicMapSearchLabel: "Search label",
  publicMapSearchLabelHint: "Empty shows the labels of the searchable layers",
  searchLabel: "Search label",
  searchLabelHint: "Shown above the search box while the layer is on",
  layerData: "Calculated data",
  layerStateNotCalculated: "Not calculated",
  layerStateCalculating: "Being calculated",
  layerStateCalculated: "Done",
  layerStateFailed: "Failed",
  layerDataBounds: "Bounding box",
  layerDataMinLat: "Min latitude",
  layerDataMinLon: "Min longitude",
  layerDataMaxLat: "Max latitude",
  layerDataMaxLon: "Max longitude",
  layerDataTable: "Table",
  layerDataCalculatedDate: "Calculated at",
  layerDataDuration: "Duration",
  layerDataSeconds: "{seconds} s",
  layerDataError: "Error message",
  refreshAllLayers: "Refresh all",
  layersRefreshed: "Marked for refresh: {reset}, skipped: {skipped}",
  menuApiKeys: "API keys",
  newApiKeyUser: "New API key",
  editApiKeyUser: "Edit API key",
  apiKeyName: "Name",
  apiKeyNameRequired: "The name is required",
  apiKeyCreateHint: "Saving creates the key and shows it once. Roles can be set after saving.",
  sectionApiKeys: "Keys",
  apiKeyRoll: "Roll key",
  apiKeyRollText: "A new key is created. The old key stays valid for the given number of minutes.",
  apiKeyGraceMinutes: "Old key stays valid (minutes)",
  apiKeyGraceHint: "With 0 the old key stops working at once",
  apiKeyGraceInvalid: "Enter a whole number from 0 to {max}",
  apiKeyRevoke: "Revoke",
  apiKeyRevokeText: "The key that starts with {prefix} stops working at once.",
  apiKeyRevokedText: "The key was revoked",
  apiKeyNone: "No keys",
  apiKeyValid: "Valid",
  apiKeyNotValid: "Not valid",
  apiKeyCreated: "Created",
  apiKeyExpires: "Expires",
  apiKeyRevoked: "Revoked",
  apiKeyLastUsed: "Last used",
  apiKeyNeverUsed: "never",
  apiKeyIssuedTitle: "The new API key",
  apiKeyIssuedText: "Copy it now. The key cannot be shown again later.",
  apiKeyCopied: "Copied",
  apiKeyUserSaved: "The API key was saved",
  apiKeyUserDeleted: "The API key was deleted",
  deleteApiKeyUserText: "The API key user {name} becomes inactive and its keys stop working.",
  tableTitle: "Table",
  tableFilterOptions: "Filter Options",
  tableChangedFrom: "Changed from",
  tableChangedTo: "Changed to",
  tableRefresh: "Refresh"
};

export type AppLabels = Labels & typeof hu;

export const appStrings: Record<AppLang, typeof hu> = { hu, en };

export function langIdOf(lang: AppLang): number {
  return lang === "en" ? 2 : 1;
}

export function langOfId(langId: number): AppLang {
  return langId === 2 ? "en" : "hu";
}

export function appLabelsFor(lang: AppLang): AppLabels {
  return { ...labelsFor(langIdOf(lang)), ...appStrings[lang] };
}

export { format };
